<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        :sm="item.type == 'radio-group' ? 12 : 6"
        v-for="(item, i) in form"
        :key="i"
      >
        <v-select
          :label="item.label"
          v-model="item.value"
          :items="item.items"
          v-if="item.type == 'select'"
          outlined
          :rules="item.rules"
          item-text="name"
          :multiple="item.multiple"
          item-value="value"
          :dense="$root.dense"
          :disabled="item.disabled"
          @input="input"
        >
        </v-select>
        <template v-else-if="item.type == 'radio-group'">
          <label> {{ item.label }}</label>
          <div class="d-flex flex-wrap">
            <v-checkbox
              v-for="(option, o) in item.items"
              :key="o"
              :value="option"
              class="mr-5"
              v-model="item.value"
              hide-details=""
              outlined
              :label="option"
              :dense="$root.dense"
              @change="input"
            ></v-checkbox>
          </div>
        </template>

        <v-text-field
          :label="item.label"
          v-model="item.value"
          outlined
          v-else
          :rules="item.rules"
          :type="item.type"
          :dense="$root.dense"
          :disabled="item.disabled"
          :max="item.counter"
          :counter="item.counter"
          @input="input"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { technicianTypes } from "../../../assets/js/default";
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      types: technicianTypes,
      phone: [
        (v) => !!v || "Please enter a valid US Phone number",
        (v) => v.length == 10 || "Please enter a valid US Phone number",
      ],
      rules: [
        (v) => !!v || "Field is required",
        (v) =>
          (v && v.length <= 255) || "Field must be less than 255 characters",
      ],
      email: [
        (v) => !v || /.+@.+\..+/.test(v) || "Please enter a valid email address"
      ],
    };
  },
  computed: {
    icon() {
      let items = this.zipcodes;
      let item = this.form.find((i) => i.key == "zones");
      if (items.length == item.value.length) return "mdi-close-box";
      if (items.length != item.value.length) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    isUpdate() {
      return this.$route.name === "technicians-update";
    },
    zones() {
      let zips = this.$store.getters.zipcodes;
      let zones = [];
      zips.forEach((item) => {
        let zone = item.zone.toLowerCase();
        if (zones.indexOf(zone) == -1) zones.push(zone);
      });
      return zones.map((i) => this.toTitleCase(i)).sort();
    },

    form: {
      get() {
        let { first_name, last_name, phone, abilities, type, zones, email } =
          this.value;
        if (type == undefined) type == "";
        let form = [
          {
            value: first_name,
            key: "first_name",
            label: "First Name",
            rules: this.rules,
            disabled: false,
            type: "text",
            counter: 255,
          },
          {
            value: last_name,
            key: "last_name",
            label: "Last Name",
            disabled: false,
            rules: this.rules,
            type: "text",
            counter: 255,
          },
          {
            value: phone,
            key: "phone",
            disabled: this.isUpdate,
            label: "Phone",
            rules: this.phone,
            type: "number",
            counter: 10,
          },
          {
            value: abilities,
            key: "abilities",
            disabled: false,
            label: "Abilities",
            rules: this.rules,
            type: "text",
            counter: 255,
          },
          {
            value: type,
            key: "type",
            disabled: false,
            label: "Technician Type",
            rules: this.rules,
            items: this.types,
            type: "select",
            counter: null,
          },
          {
            value: email,
            key: "email",
            disabled: false,
            label: "email",
            rules: this.email,
            type: "text",
            counter: 255,
          },
          {
            value: zones,
            key: "zones",
            disabled: false,
            label: "Zones",
            items: this.zones,
            rules: this.rules,
            multiple: true,
            type: "radio-group",
            counter: null,
          },
        ];
        return form;
      },
    },
  },
  methods: {
    toTitleCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    toggle() {
      this.$nextTick(() => {
        let items = this.zipcodes;
        let item = this.form.find((i) => i.key == "zones");
        if (items.length == item.value.length) {
          this.value.zones = [];
        } else {
          this.value.zones = items.slice();
        }
      });
    },
    input() {
      let form = {};
      const vm = this;
      vm.form.forEach(({ key, value }) => {
        form[key] = value;
      });
      vm.$emit("input", form);
    },
  },
  mounted() {},
};
</script>

<style></style>
